import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { ConnectedFullDeviceListTable } from "ui/full-device-list/connected-full-device-list-table";
import { QsParamController } from "ui/qs-param-controller";
import { ConnectedWsDeviceStatusConnStatus } from "ui/ws-ds-conn-status/connected-ws-ds-conn-status";
import { Page } from "view/layout/page";

class FullDeviceList extends React.PureComponent {
  static get propTypes() {
    return {
      history: PropTypes.object.isRequired,
      location: PropTypes.object.isRequired,
    };
  }

  render() {
    const { history, location } = this.props;

    return (
      <Page title="Device List">
        <Row>
          <Col xs={12}>
            <ConnectedWsDeviceStatusConnStatus />
          </Col>
        </Row>
        <QsParamController
          location={location}
          qsName="order_by"
          qsValue="status,id"
          noOverride
          onMount
        >
          <ConnectedFullDeviceListTable
            history={history}
            location={location}
            search
          />
        </QsParamController>
      </Page>
    );
  }
}

export { FullDeviceList };
